import React, { useState } from 'react';

import APModal from 'components/Modal/APModal';
import { setCookie } from 'utils/cookies';
import { authAccountWithIntegration } from 'utils/integrations';

const ReAuthIntegrationModal = ({ expiredIntegration }) => {
  const [showExpired, setShowExpired] = useState(!!expiredIntegration);
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState('');

  const handleReauthenticateAccount = async () => {
    const provider = expiredIntegration?.provider;

    if (!provider) {
      setError('No provider found for reauthentication.');
      return;
    }

    setCookie('nylas_exchange_redirect_url', document.location.pathname, 10 / 1440);
    await authAccountWithIntegration({ provider }, setError);
  };

  const reauthenticateAccountAction = (integration) => {
    return (
      <button
        className="button"
        onClick={() => handleReauthenticateAccount(integration)}
      >
        Reauthenticate Account
      </button>
    );
  };

  const errorModalCloseHandler = () => {
    setError('');
    setShowError(false);
  };

  if (!expiredIntegration) {
    return null;
  }

  return (
    <>
      <APModal
        open={showExpired}
        onClose={() => setShowExpired(false)}
        title="Heads up!"
        actions={reauthenticateAccountAction(expiredIntegration)}
        shouldCloseOnOverlayClick
      >
        <p>
          For security purposes, your Google/Apple/Outlook account needs to be reauthenticated in order to continue
          syncing with Aisle Planner. Please click below to be redirected to the authentication page.
        </p>
      </APModal>
      <APModal
        open={showError}
        onClose={errorModalCloseHandler}
        actions={(
          <button
            onClick={errorModalCloseHandler}
            className="button"
          >
            Ok
          </button>
        )}
      >
        <div>{error}</div>
      </APModal>
    </>
  );
};

export default ReAuthIntegrationModal;
